module.exports = '<svg width="51" height="32" viewBox="0 0 51 32"><path d="M49.706.474c-.96-.576-2.144-.64-3.137-.131L32.006 7.647V3.195c0-1.12-.576-2.144-1.504-2.721-.96-.576-2.144-.64-3.137-.131L1.76 13.146C.672 13.661 0 14.782 0 15.998s.672 2.336 1.76 2.852l25.605 12.799c.451.224.96.352 1.44.352.576 0 1.184-.16 1.696-.48a3.196 3.196 0 0 0 1.504-2.721v-4.417l14.563 7.265c.451.224.96.352 1.44.352.576 0 1.184-.16 1.696-.48a3.196 3.196 0 0 0 1.504-2.721V3.194c0-1.12-.576-2.144-1.504-2.721z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/rewind-2.js
// module id = 1375
// module chunks = 14